import { api } from '@cwd/lib/main';

export interface AccountUsage {
    ContactCount: number;
    EmailCount: number;
    DailyUsage: Record<string, number>;
    EmailLimitMonths: number;
    ContactLimitMonths: number;
}

export async function getUsage(): Promise<AccountUsage> {
    return api.get('/ServiceSubscriptions/Usage');
}

export async function getAITokenConsumption(): Promise<number> {
    return api.get('/OpenAI/Consumption');
}
